import styled from '@emotion/styled';
import { fontSize, fontWeight, mediaMax } from 'presentations/views/styles';
import { memo } from 'react';

interface Props {
  children?: any;
  className?: string;
  variant: 'h1' | 'h2' | 'h3' | 'h4';
}

const Component = memo((props: Props) => {
  let Headline = null;
  switch (props.variant) {
    case 'h1':
      Headline = Headline1;
      break;
    case 'h2':
      Headline = Headline2;
      break;
    case 'h3':
      Headline = Headline3;
      break;
    case 'h4':
      Headline = Headline4;
      break;
    default:
      return null;
  }
  return <Headline className={props.className}>{props.children}</Headline>;
});

const Headline1 = styled.h1`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(32)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(20)};
  }
`;

const Headline2 = styled.h2`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(24)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(18)};
  }
`;

const Headline3 = styled.h3`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(18)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(16)};
  }
`;

const Headline4 = styled.h4`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(16)};
  ${mediaMax.tablet} {
    font-size: ${fontSize(14)};
  }
`;

export default Component;
